export default "__VITE_ASSET__CM5wdcNp__"